import {injectable} from 'inversify';
import {IAsyncEventManager} from '@fantasmagames/core/src/events/_interfaces/IAsyncEventManager';
import {EventMap, Listener} from '@fantasmagames/core/src/events/_interfaces/IEventManager';

/**
 * responsible for dispatching async events
 * async events - are special type of event that fires after _logic and render phases
 * used mostly for changing the state of the game
 */
@injectable()
export class AsyncEventManager implements IAsyncEventManager {
	public _asyncEventMap: EventMap = {};

	public dispatchAsyncEvents(): void {
		for (const name in this._asyncEventMap) {
			if (this._asyncEventMap.hasOwnProperty(name)) {
				const listeners: Listener[] = this._asyncEventMap[name];

				if (listeners) {
					for (const listener of listeners) {
						listener.callback();
					}
				}
			}
		}

		this.clearAsyncEvents();
	}

	private clearAsyncEvents(): void {
		delete this._asyncEventMap;
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/core/src/events/AsyncEventManager.ts